import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { handleAMCCreateUpdate } from "../../../commonHandlerFunction/Purchase/AMC/AMCHandler";

const AmcButton = ({
  formData,
  handleSubmit,
  setIsOverlayLoader,
  setFormData,
  viewOnly,
}) => {
  const navigate = useNavigate();
  return (
    <div className="auditBtns">
      <Button
        type="button"
        className="cancelBtn"
        onClick={() => navigate("/AMCList")}
      >
        Back
      </Button>
      {!viewOnly && (
        <>
          {formData[0]?.amc_status !== "Posted" && (
            <Button
              type="button"
              className="submitBtn"
              onClick={() => {
                handleAMCCreateUpdate(
                  formData,
                  handleSubmit,
                  setIsOverlayLoader,
                  navigate,
                  "Saved",
                );
              }}
            >
              Save
            </Button>
          )}
          <Button
            type="button"
            className="submitBtn"
            onClick={() =>
              handleAMCCreateUpdate(
                formData,
                handleSubmit,
                setIsOverlayLoader,
                navigate,
                "Posted",
              )
            }
          >
            Post
          </Button>
        </>
      )}
    </div>
  );
};

export default AmcButton;
